import $ from 'zepto';
import { onDocumentReady } from '../main';

const $body = $(document.body);

export function removeFieldsError($context = $body) {
  const fieldErrorClass = 'ppvx_field--error';
  const fieldErrorSelector = `.${fieldErrorClass}`;
  const fieldInputSelector = '.ppvx_text-input__control';
  const fieldSelectSelector = '.ppvx_dropdown__control';
  const fieldRadioSelector = '.ppvx_radio__input';

  function removeErrorOnTyping(element) {
    const $this = $(element);

    $this.on('focus', () => {
      $this.val('');
    });

    $this.on('keyup keydown', (event) => {
      const keyCode = event.which;

      // if key code is that of a tab or arrow
      if ((keyCode === 9 && $this.val() === '') || (keyCode >= 37 && keyCode <= 40)) {
        return;
      }

      $this.closest(fieldErrorSelector).removeClass(fieldErrorClass);
    });
  }

  function removeErrorOnChange(element) {
    const $this = $(element);
    $this.on('change', () => {
      $this.closest(fieldErrorSelector).removeClass(fieldErrorClass);
    });
  }

  function eachField(index, item) {
    const $typingElement = $(item).find(fieldInputSelector);
    const $changeElement = $(item).find(`${fieldSelectSelector}, ${fieldRadioSelector}`);

    if ($typingElement.length) {
      removeErrorOnTyping($typingElement);
    }

    if ($changeElement.length) {
      removeErrorOnChange($changeElement);
    }
  }

  $context.find(fieldErrorSelector).each(eachField);
}

onDocumentReady('fieldsError', () => {
  removeFieldsError($body);
});
export default {
  removeFieldsError,
};
